import { cn } from "@/lib/utils";

export function CloseIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6", className)}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <rect
        height="23"
        rx="11.5"
        stroke="currentColor"
        width="23"
        x="0.5"
        y="0.5"
      />
      <path
        clipRule="evenodd"
        d="M14.297 8.293a1 1 0 111.414 1.414l-2.295 2.295 2.295 2.295a1 1 0 11-1.414 1.414l-2.295-2.295-2.294 2.295a1 1 0 11-1.415-1.414l2.295-2.295-2.295-2.295a1 1 0 011.414-1.414l2.295 2.295 2.295-2.295z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
